import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Avatar from './ui/Avatar';
import Badge from './ui/Badge';
import PhotoPlaceholder from './ui/PhotoPlaceholder';

export default function ListingCard({ listing }) {
  const navigate = useNavigate();
  const provider = listing.profiles;
  const [imgError, setImgError] = useState(false);
  return (
    <div
      onClick={() => navigate(`/listings/${listing.id}`)}
      className="bg-white border border-sand-200 rounded-lg shadow-card hover:shadow-hover hover:-translate-y-0.5 hover:border-terra-400/30 transition-all duration-200 cursor-pointer overflow-hidden"
    >
      <div className="aspect-[4/3] overflow-hidden bg-sand-100">
        {listing.cover_photo_url && !imgError ? (
          <img
            src={listing.cover_photo_url}
            alt={listing.title}
            className="w-full h-full object-cover"
            onError={() => setImgError(true)}
          />
        ) : (
          <PhotoPlaceholder />
        )}
      </div>
      <div className="p-4 flex flex-col h-[200px]">
        <Badge variant="category" className="mb-2">{listing.category}</Badge>
        <h3 className="font-heading text-base font-semibold text-ink-900 line-clamp-1 mb-1">{listing.title}</h3>
        <p className="text-sm text-ink-400 line-clamp-3 leading-relaxed flex-1">{listing.description}</p>
        <div className="flex items-center justify-between mt-4">
          {provider ? (
            <button
              onClick={e => { e.stopPropagation(); navigate(`/users/${provider?.id}`); }}
              className="flex items-center gap-2 hover:opacity-80 transition-opacity"
            >
              <Avatar
                src={provider?.avatar_url}
                name={`${provider?.first_name || ''} ${provider?.last_name || ''}`}
                size="sm"
              />
              <span className="text-sm text-ink-700">{provider?.first_name} {provider?.last_name}</span>
            </button>
          ) : <span />}
          {listing.price && <span className="text-sm font-semibold text-terra-400">AED {listing.price}</span>}
        </div>
      </div>
    </div>
  );
}
